import React, {useEffect, useState} from "react";
import brands1 from '../assets/images/brands1.jpg';
import logo from '../assets/images/logo.svg';
import {Link} from "react-router-dom";
import TopNav from "./TopNav";
import sia from "../services/Api";
import LoaderView from "../tools/LoaderView";

const About = () => {
    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);


    useEffect(() => {
        getData()
    }, []);

    const getData = async () => {
        setLoading(true)
        await sia
            .getDataFromServer("about")
            .then((res) => {
                setData(res.data.data);
            })
            .catch((err) => {
                console.log(err);
            });
        setLoading(false)
    }

    return (
        <>
            {isLoading ? <LoaderView/> : <div>
                <header>
                    <div className="pagewrapper slim2" id="header-slim">
                        <div className="container">
                            <TopNav/>
                        </div>
                    </div>
                </header>
                <div className="clear"></div>

                <div className="pagewrapper" id="about-content">
                    <div className="container">
                        <h1 className="title">درباره ما</h1>
                        <div className="text">
                            نکویار سامانه هدفمند جهت ایجاد خدمات آنلاین در زمینه‌ برگزاری مجالس ترحیم برخط و برگزاری
                            دوره
                            های ختم صلوات، قران و... ونیز دید بانی جهت تامین مایحتاج نیازمندان و محرومین می‌باشد.<br/>
                            تامین لوازم التحریر، سبد غذایی، تهیه پوشاک، ماسک و مواد بهداشتی، تامین هزینه ویزیت درمان،
                            خرید
                            جهیزیه، اجاره منزل، حمایت از خانواده زندانیان جرایم غیر عمد و امور اشتغال زایی و کارآفرینی
                            از
                            گزینه های مدنظر نکویاد جهت کمکهای نقدی می باشد.<br/>
                            سامانه نکویاد ضمن عقد قرارداد با مراکز، خیریه ها، انجمن ها و اشخاص حقیقی معتمد، دارای صلاحیت
                            و
                            با سابقه مشخص در مقوله امور خیر و دستگیری از نیازمندان، شرایط را جهت براورده سازی خواسته شما
                            خیر
                            ارجمند بابت خرید مایحتاج و موارد خدمت رسانی به ایشان مهیا می سازد و در قالب گزارشات در سایت
                            نکویاد به نشانی nekooyad.ir اطلاع رسانی می نماید.<br/>
                            این سامانه در تلاش است به عنوان عضوی از جامعه خیرین نقشی اثرگذار در زمینه فقر زدایی از
                            نیازمندان
                            و محرومین ایفا نماید و همچنین امید دارد نسبت به ایجاد اشتغال و ایجاد کارگاه های زود بازده در
                            راستای حمایت از خانواده های کم برخوردار ضمن حفظ شان و آبروی سرپرست خانواده نسبت به افزایش
                            درآمد
                            خانوار اقدام نماید.
                        </div>
                    </div>
                </div>

                <div className="pagewrapper" id="about-video">
                    <div className="container">
                        <h1 className="title">ویدئو توضیحی</h1>
                        <div className="player">
                            <div className="play"></div>
                            <video width="100%" height="100%" id="video-player" poster="assets/images/video-poster.jpg"
                                   controls>
                                <source src="" type="video/mp4"/>
                            </video>
                        </div>
                    </div>
                </div>

                <div className="pagewrapper" id="statistics">
                    <div className="container col-3">
                        <div className="right-col">
                            <div className="stat-item box-sizing">
                                <span>{data.options.about_us_help_amount1}</span>
                                مبلغ کمک شده
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{data.options.about_us_help_amount2}</span>
                                مبلغ کمک شده
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{data.salavatCount}</span>
                                صلوات ها
                            </div>
                        </div>
                        <div className="pinbar"></div>
                        <div className="left-col">
                            <div className="stat-item box-sizing">
                                <span>{data.fateheCount}</span>
                                فاتحه ها
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{data.options.today_count1}</span>
                                ثبت امروز
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{data.options.today_count2}</span>
                                ثبت امروز
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pagewrapper" id="home-brands">
                    <div className="container">
                        <h2 className="title">همکاران و خیرین</h2>
                        <div className="content">
                            <div className="brands-item">
                                <Link to="" title=""><img src={brands1} alt="b" width="" height=""/></Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title=""><img src="assets/images/brands2.jpg" alt="" width=""
                                                          height=""/></Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title=""><img src="assets/images/brands3.jpg" alt="" width=""
                                                          height=""/></Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title=""><img src="assets/images/brands4.jpg" alt="" width=""
                                                          height=""/></Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title=""><img src="assets/images/brands5.jpg" alt="" width=""
                                                          height=""/></Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title=""><img src="assets/images/brands6.jpg" alt="" width=""
                                                          height=""/></Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title=""><img src="assets/images/brands7.jpg" alt="" width=""
                                                          height=""/></Link>
                            </div>
                            <div className="brands-item">
                                <Link to="" title=""><img src="assets/images/brands8.jpg" alt="" width=""
                                                          height=""/></Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="clear"></div>
            </div>
            }
        </>
    );
}

export default About;
